import {fetchBaseQuery} from '@reduxjs/toolkit/query';

const WORKTREE_HEADER = 'X-Worktree';
const WORKTREE_STORAGE_KEY = 'worktreeName';
const WORKTREE_URL_PARAM = 'x-worktree';
const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

/**
 * Local fullstack only: `?x-worktree=<name>` routes every API call to that backend worktree
 * (`?x-worktree=` clears it), mirroring `@dms/config`. Production builds never send the header.
 */
const getWorktreeName = () => {
  if (IS_PRODUCTION_BUILD || typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }

  // Blocked storage (privacy mode, disabled cookies) throws; it simply means no override.
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(WORKTREE_URL_PARAM);
    if (fromUrl !== null) {
      localStorage.setItem(WORKTREE_STORAGE_KEY, fromUrl);
    }

    return localStorage.getItem(WORKTREE_STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

export const dmsBaseQuery = fetchBaseQuery({
  baseUrl: process.env.API_URL,
  prepareHeaders: (headers) => {
    const worktreeName = getWorktreeName();
    if (worktreeName) {
      headers.set(WORKTREE_HEADER, worktreeName);
    }

    return headers;
  },
});
